import type { ReactNode } from "react";

type Article = { title: string; body: ReactNode };

type Props = {
  articles: Article[];
};

export function LegalSection({ articles }: Props) {
  return (
    <div>
      <div
        style={{
          fontFamily: '"DM Mono", monospace',
          fontSize: 10,
          color: "var(--terracotta)",
          letterSpacing: "2px",
          textTransform: "uppercase",
          padding: "12px 18px",
          background: "var(--ivory)",
          borderLeft: "2px solid var(--terracotta)",
          marginBottom: 40,
        }}
      >
        ⚠ Placeholder — Texte légal à finaliser par un juriste avant production
      </div>
      {articles.map((a) => (
        <section key={a.title} style={{ marginBottom: 8 }}>
          <h2
            data-rp="legal-section-h2"
            style={{
              fontFamily: '"Anton", sans-serif',
              fontWeight: 400,
              fontSize: 28,
              color: "var(--charcoal)",
              letterSpacing: "-0.5px",
              textTransform: "uppercase",
              marginTop: 32,
              marginBottom: 12,
            }}
          >
            {a.title}
          </h2>
          <div
            style={{
              fontFamily: '"Playfair Display", Georgia, serif',
              fontSize: 15,
              color: "var(--charcoal)",
              lineHeight: 1.65,
            }}
          >
            {a.body}
          </div>
        </section>
      ))}
    </div>
  );
}
